import { useSelector } from "react-redux";
import { hasPermission, checkIsAdmin, PermissionId, ObjectTarget, hasDirectPermission, } from "../../../app/permissions";
import { selectUser } from "../../../redux/user/userSlice";
import FragmentCardContent from "../../../features/base/FragmentCardContent";
import { getImagesUrl } from "../../../redux/common";
import { SchoolInfo } from "../../../redux/school/schoolSlice";
import { useEffect, useMemo, useState } from "react";
import { retrieveConversationList, RetrieveConversationListRequest, selectConversationList } from "../../../redux/conversation/conversationListSlice";
import { useAppDispatch } from "../../../app/hooks";
import { ConversationInfo } from "../../../redux/conversation/conversationSlice";
import { Box, Stack } from "@mui/material";
import { ClassroomInfo } from "../../../redux/classroom/classroomSlice";
import { ConversationListContainer } from "../../../features/conversation/ConversationListContainer";
import { MessagesScreen } from "../../../features/conversation/messages/MessagesScreen";
import { getElementHeight } from "../../../app/utils";
import { NamedObject } from "../../../redux/object/namedObject";

interface ClassroomConversationProps {
    school: SchoolInfo;
    classroom: ClassroomInfo;
}

export const ClassroomConversation = (props: ClassroomConversationProps) => {
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const conversationList = useSelector(selectConversationList);
    const [selectedConversation, setSelectedConversation] = useState<ConversationInfo | undefined>(undefined);

    const isAdmin = useMemo(() => checkIsAdmin(user.priza.info), [user.priza.info]);
    const me = useMemo((): NamedObject => {
        return NamedObject.classroom(props.classroom);
    }, [props.classroom]);
    const hasMessages = useMemo(
        () => hasDirectPermission(user.priza.info, PermissionId.CLASSROOM_TEACHER, props.classroom.id) ||
            hasDirectPermission(user.priza.info, PermissionId.CLASSROOM_MESSAGE, props.classroom.id),
        [user.priza.info, props.classroom.id]);

    useEffect(() => {
        if (hasMessages) {
            const request: RetrieveConversationListRequest = {
                objectTarget: ObjectTarget.CLASSROOM,
                targetId: `${props.classroom.id}`,
            };
            dispatch(retrieveConversationList(request));
        }
    }, [hasMessages, conversationList, user, props.classroom.id]);


    if (!hasMessages) {
        return <FragmentCardContent
            image={`${getImagesUrl()}/forbidden.webp`}
            title="Messagens"
            description="Sem permissões para enviar mesnagem por esta escola."
        />;
    }

    const topHeight = getElementHeight("top-bar");
    const appNameHeight = getElementHeight("app-name");
    const appControlHeight = getElementHeight("app-control");
    const messageHeight = window.innerHeight - (2 + topHeight + appNameHeight + appControlHeight);

    return <Stack direction="row" spacing={0}>
        <Box id='contacts' sx={{ width: "400px", minWidth: "400px", maxWidth: "400px" }}>
            <ConversationListContainer
                me={me} 
                school={props.school} 
                classroom={props.classroom}
                height={messageHeight} 
            />
        </Box>
        <Box id='conversation'  sx={{ width: "100%" }}>
            <MessagesScreen height={messageHeight} 
                // me={me} 
                // schoolId={props.classroom.schoolId}
            />
        </Box>
    </Stack>;

};